import { forwardRef } from 'react';
import { cn } from 'v5/platform/dom/cn';

export type TileBoxProps = React.ComponentPropsWithRef<'div'> & {
  /** Doesn't lift on hover: a tile that can't be acted on. */
  still?: boolean;
};

/**
 * The frame every tile body draws in (`DataCard`, `ImmersiveCard`): the hairline border, the
 * corners and the shadow that lifts on hover; the muted inner ring while the tile is the current
 * one (`TileShell`'s `current`). One frame, so the two bodies can't drift apart.
 */
export const TileBox = forwardRef<HTMLDivElement, TileBoxProps>(
  ({ className, still, ...rest }, ref) => (
    <div
      ref={ref}
      className={cn(
        'overflow-hidden rounded-lg border border-border-default shadow-sm transition-[opacity,box-shadow]',
        !still && 'hocus:shadow-md',
        'group-data-current/grid-item:ring-2 group-data-current/grid-item:ring-fg-muted/50',
        className
      )}
      {...rest}
    />
  )
);
TileBox.displayName = 'TileBox';
